import { i18next } from '@yola/ws-sdk';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import controlIds from '../constants/control-ids';
import settingIds from '../constants/setting-ids';
import previewGifs from '../constants/preview-gifs';
import computeContentAlignmentFallback from '../helpers/compute-content-alignment-fallback';

const ALIGNMENTS = {
  left: {
    id: 'left',
    glyph: 'align-left',
    value: 'left',
  },
  center: {
    id: 'center',
    glyph: 'align-center',
    value: 'center',
  },
  right: {
    id: 'right',
    glyph: 'align-right',
    value: 'right',
  },
};

const getSettingsById = (settingId) => {
  switch (settingId) {
    case settingIds.THIS_COLUMN: {
      return {
        popover: {
          content: i18next.t('Align the content inside this column horizontally'),
          imgSrc: previewGifs.COLUMN_HORIZONTAL_CONTENT_ALIGNMENT_GIF,
        },
      };
    }
    case settingIds.ALL_COLUMNS: {
      return {
        querySelector: 'ws-column',
        popover: {
          content: i18next.t('Align the content inside columns horizontally'),
          imgSrc: previewGifs.COLUMNS_HORIZONTAL_CONTENT_ALIGNMENT_GIF,
        },
      };
    }
    default:
      return {};
  }
};

const getHorizontalContentAlignment = (settingId, settings = {}) => ({
  ...settings,
  ...getSettingsById(settingId),
  id: controlIds.HORIZONTAL_CONTENT_ALIGNMENT,
  title: i18next.t('Horizontal'),
  targets: [targetAttributes.HORIZONTAL_ALIGNMENT],
  computeFallbackValue: computeContentAlignmentFallback,
  choices: [
    {
      ...ALIGNMENTS.left,
      label: i18next.t('Left'),
    },
    {
      ...ALIGNMENTS.center,
      label: i18next.t('Center'),
    },
    {
      ...ALIGNMENTS.right,
      label: i18next.t('Right'),
    },
  ],
});

export default getHorizontalContentAlignment;
